import React from 'react';

import { PagingContextProvider } from '../../../contexts/paging-context';
import { usePaging } from '../../../hooks/use-paging';
import gridPageStyles from '../../../pages/grid-page.module.less';
import { useEnhancedReturnRouteMatch } from '../../../store/returns/returns.helpers';
import { EnhancedReturnsContextProvider } from './grids/enhanced-returns-context';
import { EnhancedReturnsHeader } from './header';
import { EnhancedReturnStatusTabs } from './status-tabs';

export const EnhancedReturnsContent = () => {
  const { storeGuid } = useEnhancedReturnRouteMatch();
  const paging = usePaging();
  const { page, pageSize } = paging;

  return (
    <div className={gridPageStyles['main-content']}>
      <PagingContextProvider page={page} pageSize={pageSize}>
        <EnhancedReturnsContextProvider>
          <EnhancedReturnsHeader storeGuid={storeGuid} />
          <EnhancedReturnStatusTabs />
        </EnhancedReturnsContextProvider>
      </PagingContextProvider>
    </div>
  );
};
